import { createSelector } from 'reselect';
import { fromJS, Map } from 'immutable';
import { PLATFORM } from './constants';

export const selectLocationState = (state) =>
  PLATFORM === 'web' ? state.location : state.rfrLocation;

export const selectQuery = createSelector(selectLocationState, (location) =>
  fromJS(location.query || {})
);

export const selectQueryObject = createSelector(
  selectLocationState,
  (location) => location.query || {}
);

export const selectPayload = createSelector(selectLocationState, (location) =>
  fromJS(location.params || {})
);

export const selectPayloadObject = createSelector(
  selectLocationState,
  (location) => location.params || {}
);

export const selectState = createSelector(selectLocationState, (location) =>
  fromJS(location.state || {})
);

export const selectStateObject = createSelector(
  selectLocationState,
  (location) => location.state || {}
);

export const selectType = createSelector(
  selectLocationState,
  (location) => location.type
);

export const selectPath = createSelector(
  selectLocationState,
  (location) => location.pathname
);

export const selectKind = createSelector(
  selectLocationState,
  (location) => location.kind
);

export const selectLocation = createSelector(
  [selectType, selectPayload, selectQuery, selectPath, selectKind],
  (type, params, query, pathname, kind) =>
    new Map({
      type,
      params,
      query,
      pathname,
      kind,
    })
);

export const selectLocationActionObject = createSelector(
  [selectType, selectPayloadObject, selectQueryObject, selectStateObject],
  (type, params, query, state) => ({
    type,
    params,
    query,
    state,
  })
);

export const selectRoutesMap = createSelector(
  [selectLocationState],
  (locationState) => locationState.routesMap
);

// These are temporarily until rfr is fully implemented in native.
export const selectRfrLocationForCoursePath = (state) => state.location;

export const selectTypeForCoursePath = createSelector(
  selectRfrLocationForCoursePath,
  (location) => location.type
);

export const selectPayloadForCoursePath = createSelector(
  selectRfrLocationForCoursePath,
  (location) => fromJS(location.params || {})
);

// pagination related query fields
export const makeSelectCursorPageSize = (pageSizeOptions) =>
  createSelector(selectQuery, (query) => {
    let pageSize = query.get('pageSize', '');
    pageSize = parseInt(pageSize, 10);
    if (!pageSize || !pageSizeOptions.includes(pageSize)) {
      return pageSizeOptions[0]; // default
    }

    return pageSize;
  });

export const selectCurrentCursor = createSelector([selectQuery], (query) => {
  const queryCursor = query.get('cursor', null);
  if (!queryCursor) {
    return null;
  } else {
    return JSON.parse(queryCursor);
  }
});

export const selectCurrentFilter = createSelector([selectQuery], (query) =>
  query.get('filter', null)
);
